export default __webpack_public_path__ + "static/main_logo-25ce015521230d5c57f4b89cd78aed36.svg";